export interface ParteProcessoRaw {
  id_parte_processo?: number;
  nome?: string;
  tipo?: string;
  id_parte_representada?: number | null;
}

export interface ParteRepresentadaRaw {
  id_parte_representada?: number;
  nome?: string;
  id_parte_processo?: number | null;
}

export interface ParteProcessoFormatted {
  id_parte_processo?: number;
  nome: string;
  tipo: string;
  representada: boolean;
  id_parte_representada?: number | null;
}

function isRepresentada(idParteRepresentada: number | null | undefined): boolean {
  return idParteRepresentada !== null && 
         idParteRepresentada !== undefined && 
         idParteRepresentada !== 0;
}

function isParteManual(idParteProcesso: number | null | undefined): boolean {
  return !idParteProcesso || idParteProcesso === null || idParteProcesso === 0;
}

export function convertPartesProcesso(partes: ParteProcessoRaw[]): ParteProcessoFormatted[] {
  return partes.map((parte) => ({
    id_parte_processo: parte.id_parte_processo,
    nome: parte.nome || '',
    tipo: parte.tipo || '',
    representada: isRepresentada(parte.id_parte_representada),
    id_parte_representada: parte.id_parte_representada
  }));
}

export function convertPartesRepresentadas(
  partesRepresentadas: ParteRepresentadaRaw[],
  partesProcesso: ParteProcessoRaw[]
): string[] {
  const partesRepresentadasNomes = new Set<string>();
  
  partesRepresentadas.forEach((parte) => {
    if (parte.nome && isParteManual(parte.id_parte_processo)) {
      partesRepresentadasNomes.add(parte.nome.trim());
    }
  });

  partesProcesso.forEach((parte) => {
    if (parte.nome && isRepresentada(parte.id_parte_representada)) {
      partesRepresentadasNomes.add(parte.nome.trim());
    }
  });

  return Array.from(partesRepresentadasNomes);
}

